module.exports = __webpack_public_path__ + "static/WhatIsHomestay-8cc2f2a7bf10904357caf873c51c0eb5.gif";